import { render, staticRenderFns } from "./ClientCommentTextArea.vue?vue&type=template&id=72529bc2&scoped=true&"
import script from "./ClientCommentTextArea.vue?vue&type=script&lang=js&"
export * from "./ClientCommentTextArea.vue?vue&type=script&lang=js&"
import style0 from "./ClientCommentTextArea.vue?vue&type=style&index=0&id=72529bc2&lang=scss&scoped=true&"
import style1 from "./ClientCommentTextArea.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72529bc2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCard } from 'vuetify/lib/components/VCard';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VAlert,VCard,VMenu})
